import styles from "./Tabs.module.sass";
import cn from "classnames";

const Tabs = ({
	head,
	body,
	default_ = 0,
	setType,
	index = default_,
	setHandler,
}) => {
	// const [active, setActive] = useState(default_);
	// const TabHandler = (which) => {
	// 	setActive(which);
	// };

	// useEffect(() => {
	// 	if (index !== active) {
	// 		setActive(index);
	// 	}
	// }, [index]);

	return (
		<div className={styles.container}>
			<div className={styles.head}>
				{head.map((e, i) => {
					return (
						<div
							className={cn(styles.headItem, { [styles.active]: i === index })}
							key={i}
							onClick={() => {
								if (setType) {
									setType(e);
								}
								setHandler && setHandler(i);
							}}
						>
							{e}
						</div>
					);
				})}
			</div>
			<div className={styles.body}>{(body && body[index]) || null}</div>
		</div>
	);
};

export default Tabs;
